import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MentionInsightModel } from '../../../Mentions/models/mention-insight.model';
import { ButtonTypesEnum } from '../../enums/button-types.enum';
import { ConfirmDialogModel } from '../../../Dialogs/models/confirm-dialog.model';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { ConfirmDialogComponent } from '../../../Dialogs/components/ConfirmDialog/confirm-dialog.component';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';
import { EditInsightDialogComponent } from '../../../Dialogs/components/EditInsightDialog/edit-insight-dialog.component';
import { DialogIoModel } from '../../../../Core/Dialogs/models/dialog-io.model';

@Component({
    selector: 'agpr-mention-insight-card',
    templateUrl: './mention-insight-card.component.html',
    styleUrls: ['./mention-insight-card.component.scss'],
    standalone: false
})
export class MentionInsightCardComponent {
    readonly buttonTypes = ButtonTypesEnum;

    readonly preContent = '<div style="line-height: 1.5;">';
    readonly afterContent = '</div>';

    @Input() insight: MentionInsightModel;

    @Output() insightEdited = new EventEmitter<void>();
    @Output() insightDeleted = new EventEmitter<void>();
    @Output() insightPreferred = new EventEmitter<void>();

    constructor(
        private coreDialogService: CoreDialogService,
        private localizationService: LocalizationService
    ) {
    }

    setAsPreferred(): void {
        this.insightPreferred.emit();
    }

    editInsight(): void {
        const dialogModel: DialogIoModel = {
            inputs: {
                name: this.insight.name,
                content: this.insight.content
            },
            outputs: {
                dialogClose: (res) => {
                    if (!res) {
                        return;
                    }

                    this.insight.name = res.name;
                    this.insight.content = res.content;

                    this.insightEdited.emit();
                }
            }
        };
        this.coreDialogService.open(EditInsightDialogComponent, dialogModel);
    }

    deleteInsight(): void {
        const confirmDialogModel: ConfirmDialogModel = {
            inputs: {
                heading: 'Mentions.insightCard.delete.heading',
                showCancel: true,
                message: this.localizationService.transform('Mentions.insightCard.delete.message', {insightName: this.insight.name}),
                okLabel: 'Mentions.insightCard.delete.ok'
            },
            outputs: {
                dialogClose: (confirm: boolean) => {
                    if (confirm) {
                        this.insightDeleted.emit();
                    }
                }
            }
        };

        this.coreDialogService.open(ConfirmDialogComponent, confirmDialogModel);
    }
}
